<template>
  <com-page>
    <com-card>
      <div class="mb-15px">
        <h3 v-if="type === 'created'">创建小区</h3>
        <h3 v-if="type === 'edit'">编辑小区</h3>
      </div>
      <div class="site-edit_wrapper">
        <el-form :model="ruleForm" :rules="rulesFixed" ref="ruleForm" label-width="140px">
          <el-form-item label="小区名称" prop="name">
            <el-input
              v-model="ruleForm.name"
              :disabled="disabled"
              placeholder="请输入小区名称"
              style="width: 500px"
            ></el-input>
          </el-form-item>
          <el-form-item label="场地类型" prop="type">
            <el-select
              v-model="ruleForm.refType"
              :disabled="disabled"
              placeholder="请选择场地类型"
              style="width: 500px"
            >
              <el-option
                :label="item.name"
                :value="item.code"
                v-for="(item, index) in storeType"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在地域" prop="area">
            <com-region
              :regionId.sync="regionId"
              :disabled="disabled"
              :regionLabel.sync="regionLabel"
              width="500"
            ></com-region>
          </el-form-item>
          <el-form-item label="小区地址" prop="address">
            <div>
              <el-input
                v-model="ruleForm.address"
                disabled
                placeholder="自动填充"
                style="width: 500px"
              ></el-input>
            </div>
          </el-form-item>
          <div class="flex">
            <el-form-item label="小区经度" prop="addressLon">
              <div>
                <el-input
                  v-model="ruleForm.addressLon"
                  placeholder="搜索地址后自动填充"
                  style="width: 500px"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="小区纬度" prop="addressLat">
              <div>
                <el-input
                  v-model="ruleForm.addressLat"
                  placeholder="搜索地址后自动填充"
                  style="width: 500px"
                ></el-input>
              </div>
            </el-form-item>
          </div>
          <el-form-item>
            <div class="h-400px" style="overflow: hidden">
              <com-qq-map
                ref="qqMap"
                @latlng="handleMap"
                @address="getMapAddress"
                :coordinate="{ lat: ruleForm.addressLat, lng: ruleForm.addressLon }"
              ></com-qq-map>
            </div>
          </el-form-item>
          <el-form-item label="代理商" prop="type">
            <el-select
              v-model="ruleForm.refBelongAgent"
              :disabled="disabled"
              placeholder="请选择代理商"
              style="width: 500px"
            >
              <el-option
                :label="item.name"
                :value="item.code"
                v-for="(item, index) in agentList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商家" prop="type">
            <el-select
              v-model="ruleForm.refBelongBusiness"
              :disabled="disabled"
              placeholder="请选择商家"
              style="width: 500px"
            >
              <el-option
                :label="item.name"
                :value="item.code"
                v-for="(item, index) in shopList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="成本电费" prop="costElectricCharge">
            <el-input
              v-model="ruleForm.costElectricCharge"
              @input="handleCostElectricChargeInput"
              :disabled="disabled"
              placeholder=""
              style="width: 500px"
            >
              <template slot="append">元/度</template>
            </el-input>
          </el-form-item>
          <el-form-item label="租金">
            <el-input
              v-model="ruleForm.rent"
              :disabled="disabled"
              placeholder=""
              style="width: 500px"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="服务费">
            <el-input
              v-model="ruleForm.serviceCharge"
              :disabled="disabled"
              placeholder=""
              style="width: 500px"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="负责人" prop="projectLeader">
            <el-input
              v-model="ruleForm.projectLeader"
              :disabled="disabled"
              placeholder="请输入负责人"
              style="width: 500px"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="contactNumber">
            <el-input
              v-model="ruleForm.contactNumber"
              :disabled="disabled"
              placeholder="请输入联系方式"
              style="width: 500px"
            ></el-input>
          </el-form-item>
          <el-form-item label="生效时间" prop="effectiveTime">
            <el-date-picker
              :disabled="disabled"
              v-model="ruleForm.effectiveTime"
              type="date"
              format="yyyy-MM-dd"
              placeholder="生效时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 500px"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="到期时间" prop="expireTime">
            <el-date-picker
              v-model="ruleForm.expireTime"
              type="date"
              :disabled="disabled"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="到期时间"
              style="width: 500px"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="充值套餐" prop="refRechargePlanBatch">
            <el-select
              v-model="ruleForm.refRechargePlanBatch"
              :disabled="disabled"
              placeholder="请选择充值套餐"
              style="width: 500px"
              filterable
              remote
              :remote-method="(e) => getRechargeOrderBatch(e)"
              :loading="loading"
            >
              <el-option
                :label="item.name"
                :value="item.code"
                v-for="(item, index) in rechargeOrderList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="充电收费标准" prop="refChargePlan">
            <div class="flex">
              <el-select
                v-model="ruleForm.refChargePlan"
                :disabled="type === 'edit'"
                placeholder="请选择收费标准"
                style="width: 500px"
                filterable
                remote
                :remote-method="(e) => getChargePlans(e, 1)"
                :loading="loading"
              >
                <el-option
                  :label="item.name"
                  :value="item.code"
                  v-for="(item, index) in chargePlanList"
                  :key="index"
                ></el-option>
              </el-select>
              <el-button v-if="type === 'edit'" type="text" @click="dialogVisible = true"
                >修改</el-button
              >
            </div>
          </el-form-item>
          <el-form-item label="收费标准生效时间" prop="chargePlanEffectiveTime">
            <el-date-picker
              :disabled="type === 'edit'"
              v-model="ruleForm.chargePlanEffectiveTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              placeholder="收费标准生效时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 500px"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="超时占用收费标准">
            <el-select
              v-model="ruleForm.refTimeoutChargePlan"
              :disabled="disabled"
              placeholder="请选择超时占用收费标准"
              style="width: 500px"
              filterable
              remote
              :remote-method="(e) => getChargePlans(e, 2)"
              :loading="loading"
            >
              <el-option
                :label="item.name"
                :value="item.code"
                v-for="(item, index) in outTimeChargePlanList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="限定最高功率">
            <el-input
              v-model="ruleForm.limitMaxPower"
              :disabled="disabled"
              placeholder=""
              style="width: 500px"
            >
              <template slot="append">W</template>
            </el-input>
          </el-form-item>
          <el-form-item label="最高充电时长">
            <el-input
              v-model="ruleForm.limitMaxHour"
              :disabled="disabled"
              placeholder=""
              style="width: 500px"
            >
              <template slot="append">小时</template>
            </el-input>
          </el-form-item>
          <el-form-item label="合同" prop="file">
            <com-upload-file
              accept=".pdf"
              :limit="1"
              :value.sync="fileList"
              @success="handleUploadFile"
              @delFile="handleDelFile"
              @clickFile="downloadFile"
            ></com-upload-file>
          </el-form-item>
          <div class="flex justify-end">
            <el-button @click="resetForm('ruleForm')">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')" :disabled="disabled"
              >确认</el-button
            >
          </div>
          <el-form-item> </el-form-item>
        </el-form>
      </div>
    </com-card>

    <el-dialog title="编辑收费标准" :visible.sync="dialogVisible" width="600px">
      <el-form label-width="140px">
        <el-form-item label="充电收费标准">
          <el-select
            v-model="ruleForm.refChargePlan"
            placeholder="请选择收费标准"
            style="width: 400px"
            filterable
            remote
            :remote-method="(e) => getChargePlans(e, 1)"
            :loading="loading"
          >
            <el-option
              :label="item.name"
              :value="item.code"
              v-for="(item, index) in chargePlanList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收费标准生效时间">
          <el-date-picker
            v-model="ruleForm.chargePlanEffectiveTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            placeholder="收费标准生效时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 400px"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </com-page>
</template>

<script>
import { feeStandardListApi } from '@/api/fee-standards'
import { partnersListApi } from '@/api/partners'
import {
  communityDetailApi,
  addCommunityApi,
  updateCommunityApi,
  storeTypeApi
} from '@/api/community'
import { list } from '@/api/recharge-package'
import { filterImage } from '@/filters'

import utils from 'my-tools-library'

export default {
  data() {
    return {
      code: '',
      type: '',
      disabled: false,
      regionId: [],
      regionLabel: '',
      ruleForm: {
        name: '', //名称
        refType: '', //场地类型
        areaNames: '', // 地区名称
        areaCodes: '', //地区编码
        address: '', //小区地址
        addressLat: '', // 纬度
        addressLon: '', // 经度
        costElectricCharge: '', //成本电费
        rent: '', //租金
        serviceCharge: '', //服务费
        projectLeader: '', //负责人
        contactNumber: '', //联系方式
        effectiveTime: '', //生效时间
        expireTime: '', //到期时间
        refRechargePlanBatch: '', //充值套餐
        refChargePlan: '', //充电收费标准
        chargePlanEffectiveTime: '', //收费标准生效时间
        refTimeoutChargePlan: '', // 超时占用收费标准
        limitMaxPower: '', //限定最高功率
        limitMaxHour: '', //最高充电时长
        file: '', //合同
        fileName: '', //合同名称
        updateChargePlan: false //是否更新收费标准
      },
      partners: [],
      rules: {
        name: [{ required: true, message: '请输入小区名称', trigger: 'blur' }],
        refRechargePlanBatch: [{ required: true, message: '请选择充值套餐', trigger: 'blur' }],
        refChargePlan: [{ required: true, message: '请选择充电收费标准', trigger: 'blur' }],
        costElectricCharge: [{ required: true, message: '请输入成本电费', trigger: 'blur' }],
        chargePlanEffectiveTime: [
          { required: true, message: '请选择收费标准生效时间', trigger: 'blur' }
        ] // 2025-09-19 20.23 新增
      },
      storeType: [],
      agentList: [],
      shopList: [],
      chargePlanList: [], // 充电收费标准列表
      outTimeChargePlanList: [], // 超时占用收费标准列表
      rechargeOrderList: [],
      exportQuery: {},

      initChargePlanEffectiveTime: '', // 保存充值套餐初始值
      initRefChargePlan: '', // 保存收费标准初始值
      fileList: [],
      loading: false,
      dialogVisible: false
    }
  },
  computed: {
    // 对成本电费追加小数精度与非零校验
    rulesFixed() {
      const base = this.rules || {}
      return {
        ...base,
        costElectricCharge: [
          { required: true, message: '请输入成本电费', trigger: 'blur' },
          {
            validator: (rule, value, callback) =>
              this.validateCostElectricChargeRule(rule, value, callback),
            trigger: 'change'
          },
          {
            validator: (rule, value, callback) =>
              this.validateCostElectricChargeRule(rule, value, callback),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    regionId: {
      handler(val) {
        if (val.length) {
          this.ruleForm.areaCodes = val.join(',')
          this.ruleForm.areaNames = this.regionLabel.join(',')
        }
      }
    }
  },
  created() {
    this.getStoreType()
    this.getShop(2)
    this.getShop(3)
    const { code, type } = this.$route.query
    console.log('row :>> ', code, type)
    this.type = type || 'created'
    if (code) {
      this.code = code || ''
      this.getDetail()
    }
  },
  methods: {
    // 成本电费校验：非负、最多4位小数；不允许为0，最小为0.0001
    validateCostElectricChargeRule(rule, value, callback) {
      const v = String(value || '').trim()
      if (!v) return callback(new Error('请输入成本电费'))
      const reg = /^(?:\d+)(?:\.\d{1,4})?$/
      if (!reg.test(v)) return callback(new Error('最多保留4位小数'))
      const num = Number(v)
      if (!isFinite(num) || num < 0) return callback(new Error('请输入有效的非负数'))
      if (num > 0 && num < 0.0001) return callback(new Error('最小值为0.0001（不可为0）'))
      return callback()
    },
    // 输入时即时触发校验
    handleCostElectricChargeInput() {
      if (this.$refs && this.$refs['ruleForm'])
        this.$refs['ruleForm'].validateField('costElectricCharge')
    },
    // 获取场景类型
    getStoreType() {
      const params = {
        pageIndex: 1,
        pageSize: 10000
      }
      storeTypeApi(params).then((res) => {
        const { records } = res.data
        this.storeType = records
        console.log('场景类型 :>> ', this.storeType)
      })
    },
    // 获取商家或代理商
    getShop(type) {
      if (!type) return
      const param = {
        pageIndex: 1,
        pageSize: 10000,
        type
      }
      partnersListApi(param).then((res) => {
        const { records } = res.data
        if (type === 2) this.shopList = records
        if (type === 3) this.agentList = records
      })
    },
    // 充值套餐
    getRechargeOrderBatch(e) {
      const params = {
        pageIndex: 1,
        pageSize: 20,
        name: e
      }
      this.loading = true
      list(params).then((res) => {
        this.loading = false
        const { records } = res.data
        this.rechargeOrderList = records
        console.log('充值套餐 :>> ', this.rechargeOrderList)
      })
    },
    // 收费标准
    getChargePlans(e, ruleType) {
      const params = {
        pageIndex: 1,
        pageSize: 20,
        ruleType, // 1：充电收费标准，2：超时占用收费标准
        nameCondition: e
      }
      this.loading = true
      feeStandardListApi(params).then((res) => {
        this.loading = false
        const { records } = res.data
        if (ruleType === 1) this.chargePlanList = records
        if (ruleType === 2) this.outTimeChargePlanList = records
      })
    },

    getDetail() {
      communityDetailApi({ code: this.code }).then((res) => {
        console.log('详情 :>> ', res.data)
        const row = res.data.result
        this.ruleForm = utils.deepCopy(row)
        this.regionId = row.areaCodes.split(',')
        this.regionLabel = row.areaNames.split(',')
        this.initChargePlanEffectiveTime = row.chargePlanEffectiveTime
        this.initRefChargePlan = row.refChargePlan
        this.fileList = [
          {
            name: row.fileName,
            code: row.file
          }
        ]
        this.getRechargeOrderBatch(this.ruleForm.rechargePlanBatchName)
        this.getChargePlans(this.ruleForm.chargePlanName, 1) // 充电收费标准
        this.getChargePlans(this.ruleForm.timeoutChargePlan, 2) // 超时占用收费标准
      })
    },

    handleUploadFile(res) {
      this.$set(this.ruleForm, 'file', res.data.code)
      this.$set(this.ruleForm, 'fileName', res.data.name)
    },

    handleDelFile() {
      this.ruleForm.file = ''
    },

    downloadFile(file) {
      window.open(filterImage(file.code))
    },

    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.push({ name: 'site-index' })
    },

    submitParams() {
      // 判断收费标准时间或收费标准是否存在修改
      if (
        this.initChargePlanEffectiveTime !== this.ruleForm.chargePlanEffectiveTime ||
        this.initRefChargePlan !== this.ruleForm.refChargePlan
      ) {
        this.ruleForm.updateChargePlan = true
      }

      const params = utils.deepCopy(this.ruleForm)
      return utils.cleanObject(params)
    },
    handleCreated() {
      this.disabled = true
      addCommunityApi(this.submitParams())
        .then((res) => {
          this.disabled = false
          this.$router.push({ name: 'community-management' })
        })
        .catch(() => {
          this.disabled = false
          this.$message.error('请检查填写信息')
        })
    },

    handleUpdate() {
      this.disabled = true
      updateCommunityApi(this.submitParams())
        .then((res) => {
          this.disabled = false
          this.$message.success('编辑成功')
          this.$router.push({ name: 'community-management' })
        })
        .catch(() => {
          this.disabled = false
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.type === 'created' ? this.handleCreated() : this.handleUpdate()
        }
      })
    },

    handleMap(val) {
      this.ruleForm.addressLat = val.lat
      this.ruleForm.addressLon = val.lng
    },

    getMapAddress(val) {
      this.ruleForm.address = val
    }
  }
}
</script>

<style lang="scss" scoped>
.site-edit_wrapper {
  :deep(.el-radio__inner) {
    border-radius: 2px;
  }

  :deep(.el-radio__input.is-checked) .el-radio__inner::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 0;
    display: block;
    width: 10px;
    height: 5px;
    text-align: center;
    vertical-align: middle;
    background: none;
    border: 1px solid white;
    border-top: transparent;
    border-right: transparent;
    border-radius: 0;
    transform: rotate(-45deg);
  }
}
</style>
